import { FC, useState } from 'react';

import { NamePath } from 'antd/es/form/interface';

import SelectFormItem from '@/components/form/form-items/default-items/select-form-item/SelectFormItem';

import { CellData } from '../cell-data';

type TEditableSelectFormItemProps = {
	name: NamePath;
	itemValue?: string | boolean;
	options: {
		label: string;
		value: string | boolean;
	}[];
};

export const EditableSelectFormItem: FC<TEditableSelectFormItemProps> = ({
	name,
	itemValue,
	options,
}) => {
	const [editMode, setEditMode] = useState<boolean>(true);
	const [shouldAutofocus, setShouldAutofocus] = useState<boolean>(false);

	const getValue = (value: string | boolean | undefined): string => {
		const label = options.find((option) => option.value === value)?.label;
		if (label) {
			return label;
		}
		return '';
	};

	return editMode ? (
		<SelectFormItem
			autoFocus={shouldAutofocus}
			marginBottom={0}
			name={name}
			open={shouldAutofocus ? true : undefined}
			options={options}
			placeholder=""
			placement="bottomRight"
			popupMatchSelectWidth={false}
			rules={[{ required: false }]}
			onBlur={() => {
				if (!itemValue) {
					return;
				}

				setEditMode(false);
				setShouldAutofocus(true);
			}}
			onSelect={() => {
				setEditMode(false);
				setShouldAutofocus(true);
			}}
		/>
	) : (
		<CellData
			style={{ width: '100%' }}
			onClick={() => {
				setEditMode(true);
			}}
		>
			{getValue(itemValue)}
		</CellData>
	);
};
